(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"), require("dayjs"));
	else if(typeof define === 'function' && define.amd)
		define(["vue", "dayjs"], factory);
	else if(typeof exports === 'object')
		exports["antd"] = factory(require("vue"), require("dayjs"));
	else
		root["antd"] = factory(root["Vue"], root["dayjs"]);
})(self, function(__WEBPACK_EXTERNAL_MODULE_vue__, __WEBPACK_EXTERNAL_MODULE_dayjs__) {
return 